import { defineStore } from "pinia";
import customAttributesGql from "~/helpers/queriesGrapQL/customAttributes.gql";

interface CustomAttributeItem {
  attribute_code: string;
  attribute_options: Array<Record<string, any>>
  attribute_type: string;
  entity_type: string;
  input_type: string;
  __typename: string;
}
interface CustomAttributeData {
  customAttributeMetadata?: {
    items?: Array<CustomAttributeItem>;
  };
}

export const useCustomAttributeMetadata = defineStore("customAttributeMetadata", {
  state: () => ({
    customAttributeMetadata: [],
  }),

  getters: {
    getCustomAttributeMetadata(state) {
      return state.customAttributeMetadata;
    },

    getMasterColor(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'mastercolor');
    },
    getSizes(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'size');
    },

    getLableSaleProduct(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'labels_sales');
    },
    getImageDetailPromotion(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'promotion_image_detail');
    },
    getImageListPromotion(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'promotion_image_list');
    },
    getCampainProductDetail(state) {
      return state.customAttributeMetadata.find((attribute) => attribute.attribute_code === 'campaign');
    }
  },

  actions: {
    async loadCustomAttributeMetadata() {
      const { data }: { data: CustomAttributeData } = await this.$nuxt.app.$vsf.$magento.api.customQuery({ query: customAttributesGql });
      this.customAttributeMetadata = data?.customAttributeMetadata?.items ?? null;
    },
  },
});
